"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildReportSchema = void 0;
const tslib_1 = require("tslib");
const section_builders_1 = require("./section-builders");
const utils_1 = require("../utils");
// import debug from 'debug';
// const debugLog = debug('reporting:info');
// const verboseLog = debug('reporting:verbose');
// const warnLog = debug('reporting:warning');
// const errorLog = debug('reporting:error');
/**
 * Builds an ReportSchema based on an ReportDefinition.
 * ReportSchemas are used to generate raw reports (reports represented with JSON data)
 *
 * @param {DbInterface} db An instance of DbInterface that has been connected to the relevant region.
 * @param {ReportDefinition} definition The ReportDefinition. See types.ts or README for more info and valid options.
 *
 * @returns {Promise<ReportSchema>} A promise that resolves to an ReportSchema which can be used to export this report
 */
function buildReportSchema(db, definition) {
    var _a;
    return tslib_1.__awaiter(this, void 0, void 0, function* () {
        // Grab all the schemas
        const schemas = yield (0, utils_1.getSchemas)(db, definition);
        // Build the sections
        let sectionSchemas = [];
        for (const sectionDefinition of definition.sections) {
            const sectionSchema = (0, section_builders_1.buildSection)(sectionDefinition, schemas);
            if (sectionSchema != null) {
                sectionSchemas = sectionSchemas.concat(sectionSchema);
            }
        }
        return {
            sections: sectionSchemas,
            name: definition.name,
            type: definition.type,
            organization: definition.organization,
            options: (_a = definition.options) === null || _a === void 0 ? void 0 : _a.exportOptions,
        };
    });
}
exports.buildReportSchema = buildReportSchema;
//# sourceMappingURL=index.js.map